export default "__VITE_ASSET__u6M6oOlA__"